<template>
  <section class="member-section">
    <h3 class="member-section__title">题库权益</h3>
    <div class="question-bank">
      <img
        class="question-bank__card"
        src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/member_new/questionBank-1.png"
        alt=""
        @click="goQuestionBank"
      />
      <img
        class="question-bank__card"
        src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/member_new/questionBank-2.png"
        alt=""
        @click="goQuestionBank"
      />
      <img
        class="question-bank__card"
        src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/member_new/questionBank-3.png"
        alt=""
        @click="goQuestionBank"
      />
      <img
        class="question-bank__card"
        src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/member_new/questionBank-4.png"
        alt=""
        @click="goWeekReport"
      />
    </div>
  </section>
</template>

<script>
import wx from 'weixin-js-sdk';
import { getWeekly } from '@/api/member/index';

const MEMBER_LEVELS = [10, 20, 25, 30, 40, 50, 60];

export default {
  props: {
    userInfo: {
      type: Object,
      default: () => ({}),
    },
    userMemberInfo: {
      type: Object,
      default: () => ({
        level: 0,
      }),
    },
  },
  computed: {
    isMember() {
      return MEMBER_LEVELS.includes(Number(this.userMemberInfo.level));
    },
  },
  methods: {
    goQuestionBank() {
      if (this.$root.$data.isApp) {
        this.$sendToApp('goToTkPage', 0, false);
        return;
      }
      this.$toast('请前往启航教育app题库中使用');
    },
    async goWeekReport() {
      if (!this.isMember) {
        this.jumpWeekReport('');
        return;
      }
      let weekId = '';
      try {
        const res = await getWeekly();
        if (res.code === 0 && res.data) {
          weekId = res.data.id || '';
        }
      } catch (e) {
        weekId = '';
      }
      this.jumpWeekReport(weekId);
    },
    // 与 Weekly.goStudy 一致：App 开新 WebView，小程序走 webView，H5 走路由
    jumpWeekReport(weekId) {
      const { origin } = window.location;
      const reportPath = `/ark/weekReport/detail?weekId=${weekId}&isShowFont=true`;
      if (this.$root.$data.isApp) {
        this.$sendToApp('openNewWebView', { url: `${origin}${reportPath}` }, false);
      } else if (this.$root.miniprogram) {
        const url = window.location.href;
        const [, searchParams] = url.split('?');
        let path = `${origin}${reportPath}&`;
        if (searchParams) {
          const params = searchParams.split('&');
          const paramsMap = new Map();
          params.forEach((item) => {
            const [key, value] = item.split('=');
            if (key) {
              paramsMap.set(key, value);
            }
          });
          const entries = paramsMap.entries();
          let query = '';
          const ExcludequeryArr = ['THIRD_SESSION', 'env'];
          // eslint-disable-next-line no-restricted-syntax
          for (const [key, value] of entries) {
            if (ExcludequeryArr.includes(key) && value) query += `${key}=${value}&`;
          }
          path += query;
        }
        const jumpUrl = `/subPackages/webView/webView?url=${encodeURIComponent(path)}`;
        wx.miniProgram.navigateTo({
          url: jumpUrl,
        });
      } else {
        const miniBeforePageName = localStorage.getItem('miniBeforePageName');
        if (!miniBeforePageName) {
          localStorage.setItem('miniBeforePageName', 8);
        }
        this.$router.push({
          path: '/weekReport/detail',
          query: {
            weekId,
            isShowFont: true,
          },
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.member-section {
  margin-bottom: 36px;

  &__title {
    margin: 0 36px;
    color: #333;
    font-weight: 500;
    font-size: 29px;
    font-family: PingFangSC-Medium, PingFang SC, sans-serif;
    line-height: 40px;
  }
}

.question-bank {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 678px;
  margin: 22px auto 0;

  &__card {
    display: block;
    width: 332px;
    margin-bottom: 18px;
  }
}
</style>
